import styled from "styled-components";

export const SideLine = styled.div`
    display: inline-block;
    width: .0625rem;
    height: 100%;
`